<template>
  <fragment>
    <app-header title="Settings" />

    <div class="container">
      <div class="card card-data-builder">
        <div class="card-body">
          <div class="row align-items-center mb-3">
            <div class="col">
              <h2 class="mb-0">Asset Lifecycle Report Rules</h2>
            </div>
            <div class="col-md-auto">
              <button class="btn btn-primary" @click="openDrawer()">
                <i class="far fa-plus"></i>
                Rule
              </button>
            </div>
          </div>
        </div>

        <ul class="list-data mt-0">
          <li class="data-heading d-none d-xl-block pt-4">
            <div class="row gx-2">
              <div class="col-xl-3">
                Media Owner
              </div>
              <div class="col-xl-3">
                Fault Count Rule
              </div>
              <div class="col-xl-3">
                Time Period Rule
              </div>
              <div class="col-xl-3">
                Repeating Rule
              </div>
            </div>
          </li>

          <li v-for="rule in reportRules" :key="rule.id">
            <a href="#" class="data-row" @click.prevent="openDrawer(rule)">
              <div class="row gx-2">
                <div class="col-sm-4 col-xl-3">
                  <p>
                    <span class="data-label d-xl-none">Media Owner</span>
                    {{ rule.media_owner_name }}
                  </p>
                </div>
                <div class="col-sm-4 col-xl-3">
                  <p>
                    <span class="data-label d-xl-none">Fault Count Rule</span>
                    {{ rule.fault_count_rule }}
                  </p>
                </div>
                <div class="col-sm-4 col-xl-3">
                  <p>
                    <span class="data-label d-xl-none">Time Period Rule</span>
                    {{ rule.time_period_rule }} days
                  </p>
                </div>
                <div class="col-sm-4 col-xl-3">
                  <p>
                    <span class="data-label d-xl-none">Repeating Rule</span>
                    {{ rule.repeating_rule }}
                  </p>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <report-rule-drawer
      ref="reportRuleDrawer"
      :rule="selectedRule"
      :excluded-ids="excludedOwnerIds"
      @close="closeDrawer"
      @saved="handleSaved"
    />
  </fragment>
</template>

<script>
import { stateMapper, helperComputed, helperMethods } from '@/vuex/modules/settings/report-rules'
import ReportRuleDrawer from '@/components/settings/ReportRuleDrawer'

export default {
  mixins: [
    stateMapper
  ],

  components: {
    ReportRuleDrawer
  },

  data () {
    return {
      selectedRule: null
    }
  },

  created () {
    this.getReportRules()
  },

  computed: {
    ...helperComputed,

    excludedOwnerIds () {
      return (this.reportRules || []).map(rule => rule.media_owner_id).filter(id => id !== null && id !== undefined)
    }
  },

  methods: {
    ...helperMethods,

    openDrawer (rule = null) {
      this.selectedRule = rule
      this.$refs.reportRuleDrawer.open()
    },

    closeDrawer () {
      this.selectedRule = null
    },

    async handleSaved () {
      this.closeDrawer()
      await this.getReportRules({ fresh: true })
    },

  }
}
</script>
